// import React, { useState } from "react";
// import { Helmet } from "react-helmet";
// import { FaArrowRight, FaFilePdf, FaBuilding } from "react-icons/fa";
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// const GroupCompany = () => {
//   const [selectedCompany, setSelectedCompany] = useState(null);
//   const [activeTab, setActiveTab] = useState("return");
//   const pageTitle = "Group Entities";

//   // Companies data
//   const companies = [
//     {
//       id: "bocl",
//       name: "GCPL",
//       fullName: "Grabhome Consulting Private Limited",
//       logo: "/assets/img/bocl-logo.png",
//       color: "#F26624",
//       annualReturns: [
//         {
//           year: "2024",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Group_Company/Grabhome Consulting Private Limited/grabhome_FS-2024.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "GCPL_2024",
//         },
//         {
//           year: "2023",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Group_Company/Grabhome Consulting Private Limited/GRABHOME_FS_2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "GCPL_2023",
//         },
//         {
//           year: "2022",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Group_Company/Grabhome Consulting Private Limited/Grabhome-FS_2022.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "GCPL_2022",
//         },

//         {
//           year: "2021",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Group_Company/Grabhome Consulting Private Limited/Grabhome Consulting_FS-2021.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "GCPL_2021",
//         },
//         {
//           year: "2020",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Group_Company/Grabhome Consulting Private Limited/Grabhome Consulting-FS-2020.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "GCPL_2020",
//         },

//         {
//           year: "2019",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Group_Company/Grabhome Consulting Private Limited/GRABHOME CONSULTING PVT LTD_FS_2019.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "GCPL_2019",
//         },
//       ],
//       annualReports: [
//         {
//           year: "2024",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2023-2024.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "BOCL_2023-2024",
//         },
//         {
//           year: "2023",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2022-2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "BOCL_2022-2023",
//         },
//         {
//           year: "2022",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2021-2022.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "BOCL_2021-2022",
//         },
//         {
//           year: "2021",
//           date: "October 07, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2020-2021.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "BOCL_2020-2021",
//         },
//       ],
//     },
//     {
//       id: "bpcl",
//       name: "BOVL",
//       fullName: "BLACK OPAL VENTURES LLP-AGILE",
//       logo: "/assets/img/bpcl-logo.png",
//       color: "#0066CC",
//       annualReturns: [
//         {
//           year: "2024",
//           date: "September 15, 2025",
//           url: "/assets/pdf/Group_Company/BLACK OPAL VENTURES LLP-AGILE/Black Opal Ventures LLP Financials 2024- 2025.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "BOVL_2024-2025",
//         },
//         {
//           year: "2023",
//           date: "September 15, 2025",
//           url: "/assets/pdf/Group_Company/BLACK OPAL VENTURES LLP-AGILE/agile vendor llp_FS-2023-2024.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "BOVL_2023-2024",
//         },
//       ],
//       annualReports: [
//         {
//           year: "2024",
//           date: "September 15, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/BPCL_2023-2024.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "BPCL_2023-2024",
//         },
//         {
//           year: "2023",
//           date: "September 15, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/BPCL_2022-2023.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "BPCL_2022-2023",
//         },
//       ],
//     },

//     {
//       id: "iocl",
//       name: "BOTPL",
//       fullName: "Black Opal Technologies Private Limited",
//       logo: "/assets/img/iocl-logo.png",
//       color: "#E31E24",
//       annualReturns: [
//          {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/Black Opal Technologies Private Limited/BOTPL March BS 2025.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "BOTPL_2024-2025",
//         },
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/Black Opal Technologies Private Limited/BOTPL-FS- 2023-2024.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "BOTPL_2023-2024",
//         },
//         {
//           year: "2023",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/Black Opal Technologies Private Limited/BOTPL_FS_2022-2023.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "BOTPL_2022-2023",
//         },
//         {
//           year: "2022",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/Black Opal Technologies Private Limited/BOTPL_FS_2021-2022.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "BOTPL_2021-2022",
//         },
//       ],
//       annualReports: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "IOCL_2023-2024",
//         },
//         {
//           year: "2023",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "IOCL_2022-2023",
//         },
//       ],
//     },
//     {
//       id: "hpcl",
//       name: "ARTT",
//       fullName: "AURIKA RESIDENCES-TROUBLESHOOTER TECHNOLOGIES",
//       logo: "/assets/img/hpcl-logo.png",
//       color: "#3399FF",
//       annualReturns: [
//         {
//           year: "2024",
//           date: "July 10, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA RESIDENCES-TROUBLESHOOTER TECHNOLOGIES/TROUBLESHOOTERS TECHNOLOGIES_FS 2023-2024.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "ARTT-2023-2024",
//         },

//         {
//           year: "2024",
//           date: "July 10, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA RESIDENCES-TROUBLESHOOTER TECHNOLOGIES/TROUBLESHOOTERS_FS_2022- 2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "ARTT-2022-2023",
//         },
//         {
//           year: "2024",
//           date: "July 10, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA RESIDENCES-TROUBLESHOOTER TECHNOLOGIES/TROUBLESHOOTERS TECHNO_FS_2021- 2022.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "ARTT-2021-2022",
//         },
//       ],
//       annualReports: [
//         {
//           year: "2024",
//           date: "July 10, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA RESIDENCES-TROUBLESHOOTER TECHNOLOGIES/TROUBLESHOOTERS TECHNO_FS_2021- 2022.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "ARTT-2021-2022",
//         },
//       ],
//     },
//     {
//       id: "iocl",
//       name: "APL",
//       fullName: "AURIKA PROJECTS LLP",
//       logo: "/assets/img/iocl-logo.png",
//       color: "#3399FF",
//       annualReturns: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA PROJECTS LLP/Aurika Projects LLP Financials 2024- 2025.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "APL_2024-2025",
//         },
//       ],
//       annualReports: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "IOCL_2023-2024",
//         },
//         {
//           year: "2023",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "IOCL_2022-2023",
//         },
//       ],
//     },
//     {
//       id: "iocl",
//       name: "AHPL",
//       fullName: "AURIKA HOMES PRIVATE LIMITED",
//       logo: "/assets/img/iocl-logo.png",
//       color: "#E31E24",
//       annualReturns: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA HOMES PRIVATE LIMITED/AURIKA HOMES FS 2023- 2024.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "AHPL_2023-2024",
//         },
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA HOMES PRIVATE LIMITED/Aurika Homes FS 2022-2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "AHPL_2022-2023",
//         },
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA HOMES PRIVATE LIMITED/AURIKA HOMES FS 2021-2022.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "AHPL_2021-2022",
//         },
//       ],
//       annualReports: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "IOCL_2023-2024",
//         },
//         {
//           year: "2023",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "IOCL_2022-2023",
//         },
//       ],
//     },
//     {
//       id: "iocl",
//       name: "AFML",
//       fullName: "AURIKA FACILITY MANAGEMENT LLP",
//       logo: "/assets/img/iocl-logo.png",
//       color: "#0066CC",
//       annualReturns: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA FACILITY MANAGEMENT LLP/Aurika Facility managment LLP 2024- 2025.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "AFML_2024-2025",
//         },
//       ],
//       annualReports: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "IOCL_2023-2024",
//         },
//         {
//           year: "2023",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "IOCL_2022-2023",
//         },
//       ],
//     },
//     {
//       id: "iocl",
//       name: "ADL",
//       fullName: "AURIKA DEVELOPERS LLP",
//       logo: "/assets/img/iocl-logo.png",
//       color: "#F26624",
//       annualReturns: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA DEVELOPERS LLP/Aurika Developers LLP FS 2024-2025.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "ADL_2024-2025",
//         },
//         {
//           year: "2023",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/AURIKA DEVELOPERS LLP/AURIKA DEVELOEPRS LLP-BS-2023-2024.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "ADL_2023-2024",
//         },
//       ],
//       annualReports: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "IOCL_2023-2024",
//         },
//         {
//           year: "2023",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "IOCL_2022-2023",
//         },
//       ],
//     },
//     {
//       id: "iocl",
//       name: "ABL",
//       fullName: "ADVIKA BUILDTECH LLP",
//       logo: "/assets/img/iocl-logo.png",
//       color: "#F26624",
//       annualReturns: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/ADVIKA BUILDTECH LLP/Aurika Buildtech LLP 2024- 2025.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "ABL_2024-2025",
//         },
//          {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/ADVIKA BUILDTECH LLP/ADVIKA BUILDTECH LLP FS 2023- 2024.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "ABL_2023-2024",
//         },
//          {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Group_Company/ADVIKA BUILDTECH LLP/ADVIKA FS 2022- 2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "ABL_2022-2023",
//         },

//       ],
//       annualReports: [
//         {
//           year: "2024",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
//           image: "/assets/img/Report_1.png",
//           name: "IOCL_2023-2024",
//         },
//         {
//           year: "2023",
//           date: "August 20, 2025",
//           url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
//           image: "/assets/img/Report_2.png",
//           name: "IOCL_2022-2023",
//         },
//       ],
//     },

//     //  {
//     //   id: "iocl",
//     //   name: "BOCL",
//     //   fullName: "BLACK OPAL CONSULTANTS LIMITED",
//     //   logo: "/assets/img/iocl-logo.png",
//     //   color: "#0066CC",
//     //   annualReturns: [
//     //      {
//     //       year: "2024",
//     //       date: "August 20, 2025",
//     //       url: "/assets/pdf/Group_Company/Black Opal Consultants Limited/Standalone FS BOC 31st March 2025.pdf",
//     //       image: "/assets/img/Report_2.png",
//     //       name: "Standalone FS BOC 31st March 2025",
//     //     },
//     //     {
//     //       year: "2024",
//     //       date: "August 20, 2025",
//     //       url: "/assets/pdf/Group_Company/Black Opal Consultants Limited/Consolidated FS BOC 31st March 2025.pdf",
//     //       image: "/assets/img/Report_2.png",
//     //       name: "Consolidated FS BOC 31st March 2025",
//     //     },

//     //   ],
//     //   annualReports: [
//     //     {
//     //       year: "2024",
//     //       date: "August 20, 2025",
//     //       url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
//     //       image: "/assets/img/Report_1.png",
//     //       name: "IOCL_2023-2024",
//     //     },
//     //     {
//     //       year: "2023",
//     //       date: "August 20, 2025",
//     //       url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
//     //       image: "/assets/img/Report_2.png",
//     //       name: "IOCL_2022-2023",
//     //     },
//     //   ],
//     // },
//   ];

//   const renderDocs = (docs) => (
//     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
//       {docs.map((doc, index) => (
//         <div
//           key={index}
//           className="bg-white border-1 border-[#989898] rounded-lg shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition flex flex-col"
//           onClick={() => window.open(doc.url, "_blank")}
//         >
//           {/* Top Thumbnail */}
//           <div className="!h-36 w-full border-b border-[#989898] bore !overflow-hidden bg-gray-100">
//             <img
//               src={doc.image}
//               alt={`Report ${doc.year}`}
//               className="!w-full !h-full !object-fill"
//             />
//           </div>

//           {/* Bottom Content  */}
//           <div className="px-2 mt-1 -mb-3 bg-white">
//             <div className="!flex !items-center !justify-between">
//               <div className="!flex !gap-2 items-center">
//                 <FaFilePdf className="!text-red-600 !text-lg" />
//                 <p className="!font-medium !text-sm !items-center max-w-[150px] whitespace-normal break-words">
//                   {doc.name}
//                 </p>
//               </div>
//               <div className="bg-gray-200 p-1 rounded-full">
//                 <FaArrowRight className="text-[#F26624] text-sm" />
//               </div>
//             </div>

//             <p className="!text-gray-500 !text-xs !-mt-3 !ml-7">{doc.date}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   );

//   return (
//     <>
//       <Helmet>
//         <title>{pageTitle}</title>
//       </Helmet>

//       <div className="main-content">
//         <Header />

//         <div className="min-h-screen bg-gray-50">
//           {/* Banner Section */}
//           <div
//             className="relative w-full h-64 md:h-80 lg:h-96 bg-cover bg-center"
//             style={{
//               backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(/img2/GroupofCompany.png)`,
//             }}
//           >
//             {/* <div className="absolute inset-0 flex items-center justify-center">
//           <div className="text-center text-white">
//             <h1 className="text-4xl md:text-5xl font-bold mb-2">Group Companies</h1>
//             <p className="text-lg md:text-xl">Financial Documents & Reports</p>
//           </div>
//         </div> */}
//           </div>

//           {/* Content Section */}
//           <section className="py-12 bg-white">
//             <div className="container mx-auto px-4 max-w-7xl">
//               {/* Heading */}
//               <h2 className="text-2xl !font-semibold mb-4 !text-[#F26624]">
//                 SELECT A COMPANY
//               </h2>

//               {/* Company Cards Grid */}
//               {!selectedCompany ? (
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                   {companies.map((company) => (
//                     <div
//                       key={company.id}
//                       onClick={() => setSelectedCompany(company)}
//                       className="bg-white border-2 border-gray-200 rounded-xl p-6 cursor-pointer hover:shadow-xl hover:scale-105 transition-all duration-300 hover:border-orange-500"
//                     >
//                       <div className="flex flex-col items-center text-center">
//                         <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
//                           <FaBuilding
//                             className="text-4xl"
//                             style={{ color: company.color }}
//                           />
//                         </div>
//                         <h3
//                           className="text-xl font-bold mb-2"
//                           style={{ color: company.color }}
//                         >
//                           {company.name}
//                         </h3>
//                         <p className="text-sm text-gray-600 mb-4">
//                           {company.fullName}
//                         </p>
//                         <div className="mt-auto">
//                           <span className="text-sm text-orange-500 font-medium flex items-center gap-2">
//                             View Documents <FaArrowRight />
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <>
//                   {/* Back Button & Company Info */}
//                   <div className="mb-8">
//                     <button
//                       onClick={() => {
//                         setSelectedCompany(null);
//                         setActiveTab("return");
//                       }}
//                       className="text-orange-500 hover:text-orange-600 font-medium mb-4 flex items-center gap-2 transition !bg-transparent"
//                     >
//                       <FaArrowRight className="rotate-180" /> Back to Companies
//                     </button>

//                     <div className="flex items-center gap-4 mb-6">
//                       <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
//                         <FaBuilding
//                           className="text-3xl"
//                           style={{ color: selectedCompany.color }}
//                         />
//                       </div>
//                       <div>
//                         <h2
//                           className="text-2xl font-bold"
//                           style={{ color: selectedCompany.color }}
//                         >
//                           {selectedCompany.name}
//                         </h2>
//                         <p className="text-gray-600">
//                           {selectedCompany.fullName}
//                         </p>
//                       </div>
//                     </div>

//                     {/* Tabs */}
//                     <div className="flex gap-8  border-gray-200">
//                       <button
//                         className={`pb-3 font-normal relative transition ${
//                           activeTab === "return"
//                             ? "text-orange-500 !bg-transparent"
//                             : "text-gray-500 hover:text-gray-700 !bg-transparent"
//                         }`}
//                         onClick={() => setActiveTab("return")}
//                       >
//                        Financial Reports
//                         {activeTab === "return" && (
//                           <span className="absolute left-0 -bottom-0.5 w-full h-0.5 bg-orange-500 rounded-t"></span>
//                         )}
//                       </button>

//                       {/* <button
//                         className={`pb-3 font-normal relative transition ${
//                           activeTab === "report"
//                             ? "text-orange-500 !bg-transparent"
//                             : "text-gray-500 hover:text-gray-700 !bg-transparent"
//                         }`}
//                         onClick={() => setActiveTab("report")}
//                       >
//                         Annual Report
//                         {activeTab === "report" && (
//                           <span className="absolute left-0 -bottom-0.5 w-full h-0.5 bg-orange-500 rounded-t"></span>
//                         )}
//                       </button> */}
//                     </div>
//                   </div>

//                   {/* Documents */}
//                   {activeTab === "return" &&
//                     renderDocs(selectedCompany.annualReturns)}
//                   {activeTab === "report" &&
//                     renderDocs(selectedCompany.annualReports)}
//                 </>
//               )}
//             </div>
//           </section>
//         </div>
//         <Footer />
//       </div>
//     </>
//   );
// };

// export default GroupCompany;

import React, { useState } from "react";
import {
  FaArrowRight,
  FaFilePdf,
  FaBuilding,
  FaSitemap,
  FaNetworkWired,
} from "react-icons/fa";
import Footer from "../components/Footer";
import Header from "../components/Header";

const GroupCompany = () => {
  const [selectedCategory, setSelectedCategory] = useState(null); // 'entities' or 'subsidiaries'
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [activeTab, setActiveTab] = useState("return");

  // Entities data
  const entities = [
    {
      id: "bocl",
      name: "GCPL",
      fullName: "Grabhome Consulting Private Limited",
      logo: "/assets/img/bocl-logo.png",
      color: "#F26624",
      annualReturns: [
        {
          year: "Summary",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of objects/Grabhome_Consulting_summary_of_objects.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of objects",
        },
      ],
    },

    {
      id: "hpcl",
      name: "ARPL",
      fullName: "AURIKA RESIDENCES PRIVATE LIMITED",
      logo: "/assets/img/hpcl-logo.png",
      color: "#3399FF",
      annualReturns: [
        {
          year: "3 years",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of financials/Aurika Residences Private Limited/Summary of financials of 3 years- Aurika Residences.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of financials",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "July 10, 2025",
          url: "/assets/pdf/Group_Company/AURIKA RESIDENCES-TROUBLESHOOTER TECHNOLOGIES/TROUBLESHOOTERS TECHNO_FS_2021- 2022.pdf",
          image: "/assets/img/Report_2.png",
          name: "ARTT-2021-2022",
        },
      ],
    },

    {
      id: "bpcl",
      name: "BOVL",
      fullName: "BLACK OPAL VENTURES LLP",
      logo: "/assets/img/bpcl-logo.png",
      color: "#0066CC",
      annualReturns: [
        {
          year: "3 years",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of financials/Black Opal Ventures LLP/Summary of financials of last 3 years- BOV.pdf"),
          image: "/assets/img/Report_1.png",
          name: "Summary of financials",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "September 15, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/BPCL_2023-2024.pdf",
          image: "/assets/img/Report_2.png",
          name: "BPCL_2023-2024",
        },
        {
          year: "2023",
          date: "September 15, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/BPCL_2022-2023.pdf",
          image: "/assets/img/Report_1.png",
          name: "BPCL_2022-2023",
        },
      ],
    },

 
    {
      id: "iocl",
      name: "APL",
      fullName: "AURIKA PROJECTS LLP",
      logo: "/assets/img/iocl-logo.png",
      color: "#3399FF",
      annualReturns: [
        {
          year: "3 years",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of financials/Aurika Projects LLP/Summary of financials of 3 years- Aurika Projects LLP.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of financials",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
          image: "/assets/img/Report_1.png",
          name: "IOCL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
          image: "/assets/img/Report_2.png",
          name: "IOCL_2022-2023",
        },
      ],
    },

    {
      id: "iocl",
      name: "AHPL",
      fullName: "AURIKA HOMES PRIVATE LIMITED",
      logo: "/assets/img/iocl-logo.png",
      color: "#E31E24",
      annualReturns: [
        {
          year: "3 years",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of financials/Aurika Homes Private Limited/Summary of financials 3 years- Aurika Homes Private Limited.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of financials",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
          image: "/assets/img/Report_1.png",
          name: "IOCL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
          image: "/assets/img/Report_2.png",
          name: "IOCL_2022-2023",
        },
      ],
    },

    {
      id: "iocl",
      name: "AFML",
      fullName: "AURIKA FACILITY MANAGEMENT LLP",
      logo: "/assets/img/iocl-logo.png",
      color: "#0066CC",
      annualReturns: [
        {
          year: "3 years",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of financials/Aurika Facility Managment LLP/Summary of financials 3 years- Aurika Facility Managment LLP.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of financials",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
          image: "/assets/img/Report_1.png",
          name: "IOCL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
          image: "/assets/img/Report_2.png",
          name: "IOCL_2022-2023",
        },
      ],
    },

    {
      id: "iocl",
      name: "ADL",
      fullName: "AURIKA DEVELOPERS LLP",
      logo: "/assets/img/iocl-logo.png",
      color: "#F26624",
      annualReturns: [
        {
          year: "3 years",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of financials/Aurika Developers LLP/Summary of financials of 3 years- Aurika Developers LLP.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of financials",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
          image: "/assets/img/Report_1.png",
          name: "IOCL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
          image: "/assets/img/Report_2.png",
          name: "IOCL_2022-2023",
        },
      ],
    },

    {
      id: "iocl",
      name: "ABL",
      fullName: "ADVIKA BUILDTECH LLP",
      logo: "/assets/img/iocl-logo.png",
      color: "#F26624",
      annualReturns: [
        {
          year: "3 years",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of financials/Advika Buildtech LLP/Summary of financials for 3 years- Advika.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of financials",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
          image: "/assets/img/Report_1.png",
          name: "IOCL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
          image: "/assets/img/Report_2.png",
          name: "IOCL_2022-2023",
        },
      ],
    },








    {
      id: "aell",
      name: "AELL",
      fullName: "AURIKA ESTATES LLP",
      logo: "/assets/img/iocl-logo.png",
      color: "#3399FF",
      annualReturns: [
        {
          year: "3 years",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of financials/Aurika Estates LLP/Summary_of_financials_3_years-_Aurika_Estates_LLP.pdf"),
          image: "/assets/img/Report_1.png",
          name: "Summary of financials",
        },
      ],
      annualReports: [],
    },

     {
      id: "iocl",
      name: "BOFS",
      fullName: "BLACKOPAL FINANCIAL SERVICES PRIVATE LIMITED",
      logo: "/assets/img/iocl-logo.png",
      color: "#F26624",
      annualReturns: [
        {
          year: "3 years",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of financials/Black Opal Financials Services/Summary of financials of 3 years- BOFS.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of financials",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
          image: "/assets/img/Report_1.png",
          name: "IOCL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
          image: "/assets/img/Report_2.png",
          name: "IOCL_2022-2023",
        },
      ],
    },







      {
      id: "iocl",
      name: "BCAL",
      fullName: "BROADWAY CAPITAL ADVISORS LLP",
      logo: "/assets/img/iocl-logo.png",
      color: "#3399FF",
      annualReturns: [
        {
          year: "Summary",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of objects/Broadway_Summary_of_Objects.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of objects",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
          image: "/assets/img/Report_1.png",
          name: "IOCL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
          image: "/assets/img/Report_2.png",
          name: "IOCL_2022-2023",
        },
      ],
    },






  {
      id: "iocl",
      name: "MIPL",
      fullName: "MIRV INFRA PRIVATE LIMITED",
      logo: "/assets/img/iocl-logo.png",
      color: "#0066CC",
      annualReturns: [
        {
          year: "Summary",
          date: "October 07, 2025",
          url: encodeURI("/assets/Summary of objects/MIRV_Summary_of_objects.pdf"),
          image: "/assets/img/Report_2.png",
          name: "Summary of objects",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
          image: "/assets/img/Report_1.png",
          name: "IOCL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
          image: "/assets/img/Report_2.png",
          name: "IOCL_2022-2023",
        },
      ],
    },




  ];

  // Subsidiaries data
  const subsidiaries = [
     {
      id: "iocl",
      name: "BOTPL",
      fullName: "Black Opal Technologies Private Limited",
      logo: "/assets/img/iocl-logo.png",
      color: "#E31E24",
      annualReturns: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Group_Company/Black Opal Technologies Private Limited/BOTPL March BS 2025.pdf",
          image: "/assets/img/Report_2.png",
          name: "BOTPL_2024-2025",
        },
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Group_Company/Black Opal Technologies Private Limited/BOTPL-FS- 2023-2024.pdf",
          image: "/assets/img/Report_2.png",
          name: "BOTPL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Group_Company/Black Opal Technologies Private Limited/BOTPL_FS_2022-2023.pdf",
          image: "/assets/img/Report_1.png",
          name: "BOTPL_2022-2023",
        },
        {
          year: "2022",
          date: "August 20, 2025",
          url: "/assets/pdf/Group_Company/Black Opal Technologies Private Limited/BOTPL_FS_2021-2022.pdf",
          image: "/assets/img/Report_1.png",
          name: "BOTPL_2021-2022",
        },
      ],
      annualReports: [
        {
          year: "2024",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2023-2024.pdf",
          image: "/assets/img/Report_1.png",
          name: "IOCL_2023-2024",
        },
        {
          year: "2023",
          date: "August 20, 2025",
          url: "/assets/pdf/Financial_Reports/Annual_Report/IOCL_2022-2023.pdf",
          image: "/assets/img/Report_2.png",
          name: "IOCL_2022-2023",
        },
      ],
    },
  ];

  const renderDocs = (docs) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
      {docs.map((doc, index) => (
        <div
          key={index}
          className="bg-white border-1 border-[#989898] rounded-lg shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition flex flex-col"
          onClick={() => window.open(doc.url, "_blank")}
        >
          {/* Top Thumbnail */}
          <div className="!h-36 w-full border-b border-[#989898] bore !overflow-hidden bg-gray-100">
            <img
              src={doc.image}
              alt={`Report ${doc.year}`}
              className="!w-full !h-full !object-fill"
            />
          </div>

          <div className="px-3 py-3 bg-white">
            <div className="flex items-start justify-between gap-2">
              <div className="flex gap-2 min-w-0 flex-1">
                <FaFilePdf className="!text-red-600 !text-lg shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p
                    className="!m-0 !p-0 !text-left !font-medium !text-sm !leading-snug"
                    style={{ textAlign: "left" }}
                  >
                    {doc.name}
                  </p>
                  <p
                    className="!m-0 !mt-1 !p-0 !text-left !text-gray-500 !text-xs !leading-normal"
                    style={{ textAlign: "left" }}
                  >
                    {doc.date}
                  </p>
                </div>
              </div>
              <div className="bg-gray-200 p-1 rounded-full shrink-0">
                <FaArrowRight className="text-[#F26624] text-sm" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Banner Section */}

      
      <Header />
     <div
          className="relative h-[30vh] sm:h-[60vh] md:h-[50vh] lg:h-[70vh] w-full bg-no-repeat bg-cover bg-center mb-3"
          style={{
            backgroundImage: `url(/img2/GroupofCompany.png)`,
          }}
        >
          <div className="absolute left-4 sm:left-8 md:left-12 top-1/2 transform -translate-y-1/2 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-normal text-white px-4 sm:px-8 md:px-20 font-serif">
            Group - Entities
          </div>
        </div>

      {/* Content Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-7xl">
          {/* Category Selection (Initial Screen) */}
          {!selectedCategory && (
            <>
              <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">
                Select Category
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                {/* Entities Card */}
                <div
                  onClick={() => setSelectedCategory("entities")}
                  className="bg-gradient-to-br from-orange-50 to-orange-100 border-2 border-orange-300 rounded-2xl p-8 cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300 group"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-24 h-24 rounded-full bg-white shadow-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                      <FaBuilding className="text-5xl text-orange-500" />
                    </div>
                    <h3 className="text-2xl font-bold mb-3 text-gray-800">
                      Entities
                    </h3>
                    <p className="text-gray-600 mb-6">
                      View our core business entities and their financial
                      documents
                    </p>
                    <div className="mt-auto">
                      <span className="text-orange-500 font-semibold flex items-center gap-2 text-lg">
                        Explore Entities{" "}
                        <FaArrowRight className="group-hover:translate-x-2 transition-transform" />
                      </span>
                    </div>
                    <div className="mt-4 px-4 py-2 bg-white rounded-full text-sm text-gray-600">
                      {entities.length} Companies
                    </div>
                  </div>
                </div>

                {/* Subsidiaries Card */}
                <div
                  onClick={() => setSelectedCategory("subsidiaries")}
                  className="bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-blue-300 rounded-2xl p-8 cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300 group"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-24 h-24 rounded-full bg-white shadow-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                      <FaNetworkWired className="text-5xl text-blue-500" />
                    </div>
                    <h3 className="text-2xl font-bold mb-3 text-gray-800">
                      Subsidiaries
                    </h3>
                    <p className="text-gray-600 mb-6">
                      Access our subsidiary companies and their financial
                      reports
                    </p>
                    <div className="mt-auto">
                      <span className="text-blue-500 font-semibold flex items-center gap-2 text-lg">
                        Explore Subsidiaries{" "}
                        <FaArrowRight className="group-hover:translate-x-2 transition-transform" />
                      </span>
                    </div>
                    <div className="mt-4 px-4 py-2 bg-white rounded-full text-sm text-gray-600">
                      {subsidiaries.length} Companies
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Company Grid (After Category Selection) */}
          {selectedCategory && !selectedCompany && (
            <>
              <div className="mb-8">
                <button
                  onClick={() => setSelectedCategory(null)}
                  className="text-orange-500 hover:text-orange-600 font-medium mb-6 flex items-center gap-2 transition bg-transparent border-none cursor-pointer"
                >
                  <FaArrowRight className="rotate-180" /> Back to Categories
                </button>

                <div className="flex items-center gap-3 mb-6">
                  {selectedCategory === "entities" ? (
                    <>
                      <FaBuilding className="text-4xl text-orange-500" />
                      <h2 className="text-3xl font-bold text-gray-800">
                        Entities
                      </h2>
                    </>
                  ) : (
                    <>
                      <FaNetworkWired className="text-4xl text-blue-500" />
                      <h2 className="text-3xl font-bold text-gray-800">
                        Subsidiaries
                      </h2>
                    </>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {(selectedCategory === "entities"
                  ? entities
                  : subsidiaries
                ).map((company) => (
                  <div
                    key={company.id}
                    onClick={() => setSelectedCompany(company)}
                    className="bg-white border-2 border-gray-200 rounded-xl p-6 cursor-pointer hover:shadow-xl hover:scale-105 transition-all duration-300 hover:border-orange-500"
                  >
                    <div className="flex flex-col items-center text-center">
                      <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                        <FaBuilding
                          className="text-4xl"
                          style={{ color: company.color }}
                        />
                      </div>
                      <h3
                        className="text-xl font-bold mb-2"
                        style={{ color: company.color }}
                      >
                        {company.name}
                      </h3>
                      <p className="text-sm text-gray-600 mb-4">
                        {company.fullName}
                      </p>
                      <div className="mt-auto">
                        <span className="text-sm text-orange-500 font-medium flex items-center gap-2">
                          View Documents <FaArrowRight />
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Company Details (After Company Selection) */}
          {selectedCompany && (
            <>
              <div className="mb-8">
                <button
                  onClick={() => {
                    setSelectedCompany(null);
                    setActiveTab("return");
                  }}
                  className="text-orange-500 hover:text-orange-600 font-medium mb-4 flex items-center gap-2 transition bg-transparent border-none cursor-pointer"
                >
                  <FaArrowRight className="rotate-180" /> Back to Companies
                </button>

                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
                    <FaBuilding
                      className="text-3xl"
                      style={{ color: selectedCompany.color }}
                    />
                  </div>
                  <div>
                    <h2
                      className="text-2xl font-bold"
                      style={{ color: selectedCompany.color }}
                    >
                      {selectedCompany.name}
                    </h2>
                    <p className="text-gray-600">{selectedCompany.fullName}</p>
                  </div>
                </div>

                {/* Tabs */}
                <div className="flex gap-8 border-b border-gray-200">
                  <button
                    className={`pb-3 font-normal relative transition bg-transparent border-none cursor-pointer ${
                      activeTab === "return"
                        ? "text-orange-500"
                        : "text-gray-500 hover:text-gray-700"
                    }`}
                    onClick={() => setActiveTab("return")}
                  >
                    Financial Reports
                    {activeTab === "return" && (
                      <span className="absolute left-0 -bottom-0.5 w-full h-0.5 bg-orange-500 rounded-t"></span>
                    )}
                  </button>
                </div>
              </div>

              {/* Documents */}
              {activeTab === "return" &&
                renderDocs(selectedCompany.annualReturns)}
            </>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default GroupCompany;
